module.exports = __webpack_public_path__ + "static/media/ko-KR.cef0aea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/ko-KR.png
// module id = 950
// module chunks = 0